// An overlay a URL param opens (BRK-S347, BRK-S357): the quote popup's
// `?quote=<card key>` and Preview submission's `?preview=1`. Opening pushes an
// entry carrying the overlay's mark, so the browser's (or a phone's) Back
// closes it, and a link opens it directly. URL state is the client state
// NN #9 allows.

/** The search with `param` set to `value`, or removed, other params kept. */
export function writeParam(
  params: URLSearchParams,
  param: string,
  value: string | null,
): string {
  const next = new URLSearchParams(params);
  if (value) next.set(param, value);
  else next.delete(param);
  const search = next.toString();
  return search ? `?${search}` : "";
}

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null && !Array.isArray(value);

/** Whether the overlay that marks with `mark` pushed this entry, so closing
 *  it goes back. */
export function pushedBy(state: unknown, mark: string): boolean {
  return isRecord(state) && state[mark] === true;
}

/** An entry's state with the overlay's mark. What the page was handed stays:
 *  the WC wizard hands its fan-out in it (BRK-S305). */
export function withMark(
  state: unknown,
  mark: string,
): Record<string, unknown> {
  return { ...(isRecord(state) ? state : {}), [mark]: true };
}
